
import React from 'react';
import loaderLogo from '@/Assets/state=1.png';
import {
    FloatingFocusManager,
    FloatingOverlay,
    FloatingPortal,
    useDismiss,
    useFloating,
    useInteractions
} from "@floating-ui/react";

const LoadingDialog = ({ isOpen }) => {

    const { context } = useFloating({
        open: isOpen
    });

    const dismiss = useDismiss(context, {
        outsidePress: false
    });

    const { getFloatingProps } = useInteractions([
        dismiss
    ]);


    return (
        <>
            {isOpen && (
                <FloatingPortal>
                    <FloatingOverlay className="z-[1200] flex items-center justify-center bg-white bg-opacity-60" lockScroll>
                        <FloatingFocusManager context={context}>
                            <div className={`bg-transparent relative`} {...getFloatingProps()}>
                                <img src={loaderLogo} className='animate-spin-slow w-[80px] h-[80px]' alt="loader" />
                            </div>
                        </FloatingFocusManager>
                    </FloatingOverlay>
                </FloatingPortal>
            )}
            {!isOpen && null}
        </>
    );
};

export default LoadingDialog;